import React, { useRef, useState, useEffect } from "react";
import { Columns3, RotateCcw, Search, X } from "lucide-react";
import {
    reportAccent,
    reportBtnSecondary,
    reportDropdownPanel,
    reportHeading,
    reportInput,
    reportMutedText,
    reportToolbarRow,
} from "./reportTheme";

const ReportGridToolbar = ({
    searchText,
    onSearchChange,
    onClearSearch,
    columns = [],
    visibleKeys = [],
    onToggleColumn,
    onShowAllColumns,
    onResetPreferences,
}) => {
    const [open, setOpen] = useState(false);
    const panelRef = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    return (
        <div className={reportToolbarRow}>
            <div className="relative min-w-[200px] max-w-md flex-1">
                <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                <input
                    type="text"
                    value={searchText}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="Search in table..."
                    className={`${reportInput} pl-10 pr-9`}
                />
                {searchText && (
                    <button
                        type="button"
                        onClick={onClearSearch}
                        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-0.5 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
                    >
                        <X className="h-4 w-4" />
                    </button>
                )}
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <div className="relative" ref={panelRef}>
                    <button type="button" onClick={() => setOpen((o) => !o)} className={reportBtnSecondary}>
                        <Columns3 className="h-4 w-4" />
                        Columns ({visibleKeys.length}/{columns.length})
                    </button>
                    {open && (
                        <div className={reportDropdownPanel}>
                            <div className="mb-2 flex justify-between">
                                <span className={`text-xs font-semibold uppercase ${reportMutedText}`}>
                                    Visible columns
                                </span>
                                <button
                                    type="button"
                                    onClick={onShowAllColumns}
                                    className={`text-xs font-semibold hover:underline ${reportAccent}`}
                                >
                                    Show all
                                </button>
                            </div>
                            <ul className="space-y-1">
                                {columns.map((col) => (
                                    <li key={col.key}>
                                        <label
                                            className={`flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-sm
                                                        hover:bg-gray-100 dark:hover:bg-gray-800 ${reportHeading}`}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={visibleKeys.includes(col.key)}
                                                onChange={() => onToggleColumn(col.key)}
                                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 dark:border-gray-600"
                                            />
                                            {typeof col.label === "string" ? col.label : col.key}
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
                <button type="button" onClick={onResetPreferences} className={reportBtnSecondary}>
                    <RotateCcw className="h-4 w-4" />
                    Reset view
                </button>
            </div>
        </div>
    );
};

export default ReportGridToolbar;
